import { useTenant, useTranslation } from '@parcel2go/npm-p2g-app';
import { LabelLinks } from './book/LabelLinks';
import { P2GBox, P2GButton, P2GChip, P2GLink, P2GText } from '@parcel2go/core-ui';
import { TenantSettingKeys } from '~/lib/consts/tenant-setting-keys';
import { AppCard } from '~/components/card/app-card';
import { P2GSidePanel } from '~/components/sidepanel';
import { useState } from 'react';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  statuses: { orderLineId: number; status: string }[];
  link: string;
  wrapper: (children: React.ReactNode) => React.ReactNode;
}

const OrderIndividualLabels = ({ link, statuses, wrapper }: props) => {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const { tenant, settings } = useTenant();
  const [open, setOpen] = useState(false);

  // We only want to show this if there are more than 1 orderlines.
  if (!statuses || statuses.length <= 1) {
    return null;
  }

  return wrapper(
    <>
      <P2GLink onClick={() => setOpen(true)}>{link}</P2GLink>
      <P2GSidePanel
        width="650px"
        open={open}
        onClose={() => setOpen(false)}
        anchor="right"
        title={t('ORDER_INDIVIDUAL_LABELS_PANEL_TITLE', 'Order Labels')}
      >
        {statuses.map((ol) => (
          <P2GBox key={ol.orderLineId} mt={2}>
            <AppCard>
              <P2GBox p={2}>
                <P2GBox display="flex" alignItems="center" justifyContent="space-between" gap={1}>
                  <P2GText variant="subtitle2">
                    {settings[TenantSettingKeys.OrderLinePrefix]}
                    {ol.orderLineId}
                  </P2GText>
                  <P2GChip
                    size="small"
                    color={ol.status === 'Ready' ? 'success' : 'default'}
                    label={t(`ORDER_LABELS_STATUS_${ol.status.toUpperCase()}_LABEL`, ol.status)}
                  />
                </P2GBox>
                {ol.status === 'Ready' && (
                  <P2GBox mt={2}>
                    <LabelLinks
                      isParent={false}
                      links={[
                        {
                          Type: 'ORDER-LABELS-STATUS',
                          Href: `/${tenant}/labels/authenticated/status?orderLineIds=${ol.orderLineId}&orderLineId=${ol.orderLineId}`,
                          Label: ''
                        }
                      ]}
                      tag=""
                      variant="label"
                    />
                  </P2GBox>
                )}
              </P2GBox>
            </AppCard>
          </P2GBox>
        ))}
        <P2GBox mt={4}>
          <P2GButton onClick={() => setOpen(false)}>{t('CLOSE_BUTTON', 'Close')}</P2GButton>
        </P2GBox>
      </P2GSidePanel>
    </>
  );
};

export default OrderIndividualLabels;
